<script>
import AdminLayout from '@layouts/admin-main'
import BrokerageShareList from '@components/admin/brokerage-share-list'

export default {
  page: {
    title: 'Admin::BrokerageShareList',
    meta: [{ name: 'description', content: 'Admin::BrokerageShareList' }],
  },
  components: { AdminLayout, BrokerageShareList },
}
</script>

<template>
  <AdminLayout>
    <BrokerageShareList></BrokerageShareList>
  </AdminLayout>
</template>

<style lang="scss" module>
@import '@design';
</style>
